import { render, staticRenderFns } from "./KlasifikasiRincian.vue?vue&type=template&id=59b8505d&lang=pug&"
import script from "./KlasifikasiRincian.vue?vue&type=script&lang=js&"
export * from "./KlasifikasiRincian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports